/**
 * 活动报名相关api
 *
 * @param http
 * @returns {{pushError2DingTalk(*): *, modifyPassword(*): *, queryAll(*): *}|*}
 */
export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/activity/signin/query',
                data
            })
        },

        list (data){
            return http.json({
                url: '/activity/signin/list',
                data
            })
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/activitySignIn.js